import type { Session } from "@supabase/supabase-js";
import { createContext } from "react";

export type AuthContextValue = {
  /**
   * `undefined` while the stored session is still being read — distinct from
   * `null`, which means definitively signed out. Route guards need to tell
   * those apart or they redirect on every reload before Supabase has answered.
   */
  session: Session | null | undefined;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
